// frontend/src/utils/userId.js

import { v4 as uuidv4 } from 'uuid';

// Function to get a cookie by name
export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
};

// Function to set a cookie
export const setCookie = (name, value, days) => {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${value || ''}${expires}; path=/; SameSite=Lax`;
};

const USER_ID_DAYS = 365;

// The expiry used to be set only when the id was created, so even a daily
// player became a stranger — new streak, new leaderboard name — a year after
// their first visit. It is now pushed out on the first read of each page load,
// so the id lasts a year from the *last* visit.
//
// Safari still deletes script-set cookies after 7 days without a visit; only a
// server-set cookie gets round that.
let refreshedThisLoad = false;

// Function to get or create a userId
export const getUserId = () => {
  let userId = getCookie('userId');
  if (!userId) {
    userId = uuidv4();
    setCookie('userId', userId, USER_ID_DAYS);
  } else if (!refreshedThisLoad) {
    setCookie('userId', userId, USER_ID_DAYS);
  }
  refreshedThisLoad = true;
  return userId;
};